export type BillingsTaxiTaxiEditRequestNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date;
  checkoutEventId: string | null;
  plannedDate: Date;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiTaxiEditRequestContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsTaxiTaxiEditRequestContributionBonusFavorableDistance = {
  type: BillingsTaxiTaxiEditRequestContributionType.BONUS_FAVORABLE_DISTANCE;
  comment: string | null;
  distance: number;
  rate: number;
};

export type BillingsTaxiTaxiEditRequestContributionBonusOther = {
  type: BillingsTaxiTaxiEditRequestContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditRequestContributionPenaltyWrongRoute = {
  type: BillingsTaxiTaxiEditRequestContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditRequestContributionPenaltyBeingLate = {
  type: BillingsTaxiTaxiEditRequestContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditRequestContributionPenaltyIncompatibleCar = {
  type: BillingsTaxiTaxiEditRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditRequestContributionPenaltyOther = {
  type: BillingsTaxiTaxiEditRequestContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditRequestContributionBonus =
  | BillingsTaxiTaxiEditRequestContributionBonusFavorableDistance
  | BillingsTaxiTaxiEditRequestContributionBonusOther;

export type BillingsTaxiTaxiEditRequestContributionPenalty =
  | BillingsTaxiTaxiEditRequestContributionPenaltyWrongRoute
  | BillingsTaxiTaxiEditRequestContributionPenaltyBeingLate
  | BillingsTaxiTaxiEditRequestContributionPenaltyIncompatibleCar
  | BillingsTaxiTaxiEditRequestContributionPenaltyOther;

export type BillingsTaxiTaxiEditRequestContribution =
  | BillingsTaxiTaxiEditRequestContributionBonus
  | BillingsTaxiTaxiEditRequestContributionPenalty;

export type BillingsTaxiTaxiEditRequestBody = {
  billingNodes: BillingsTaxiTaxiEditRequestNode[];
  billingContributions: BillingsTaxiTaxiEditRequestContribution[];
};

type BillingsTaxiTaxiEditRequest = {
  billingUuid: string;
  billingNodes: BillingsTaxiTaxiEditRequestNode[];
  billingContributions: BillingsTaxiTaxiEditRequestContribution[];
};

export default BillingsTaxiTaxiEditRequest;
